import SliderHero from "./SliderHero"
import DetailedHero from "./DetailedHero"

export { DetailedHero, SliderHero }
